/** search for a dataset in every set of every dataset category */
export const getDataset = (getState, id) => {
  const { datasets } = getState();
  const categoryKeys = Object.keys(datasets);
  let dataset = null;
  categoryKeys.every(
    (key) => {
      const domainDatasets = datasets[key].datasets;
      if (domainDatasets) {
        const datasetsKeys = Object.keys(domainDatasets);
        return datasetsKeys.every(
          (title) => {
            if (domainDatasets[title].id === id) {
              dataset = domainDatasets[title];
              return false; // break
            }
            return true; // continue
          }
        );
      }
      return true; // continue
    }
  );

  return dataset;
};
